export const PremiumMembershipBannerSM = () => {
  const benefits = [
    "Spend your points like cash",
    "Unlimited coupon redemptions",
    "Premium-only exclusive deals",
    "Zero in-app ads.",
  ];

  return (
   <section className="relative  w-full flex justify-center bg-white overflow-hidden px-4 ">

  <div className="w-full max-w-[1700px] py-10 md:py-6 flex flex-col items-center text-center relative ">

    {/* LABEL */}
    <div className="flex items-center gap-2 mb-4 md:mb-6 ">
      <div className="w-[10px] h-[10px] md:w-[10px] md:h-[10px] rounded-full bg-red-600" />
      <span className="text-[18px] md:text-[20px] text-neutral-700">
        Premium Membership
      </span>
    </div>

    {/* TITLE */}
    <h2 className="text-[18px] sm:text-4xl md:text-[72px] leading-tight md:leading-[1.1] font-semibold text-neutral-900 mb-4 md:mb-6">
      Unlock the Full Experience.
    </h2>

    {/* DESCRIPTION */}
    <p className="max-w-[95%] md:max-w-[650px] text-[12px] md:text-[20px] text-neutral-600 mb-10 md:mb-14">
      Upgrade to Premium to turn points into real savings, unlock exclusive
      deals, and enjoy an ad-free experience.
    </p>

    {/* BENEFITS */}
    <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-12 md:mb-[80px] w-full items-center">
      {benefits.map((text, i) => (
        <div
          key={i}
          className="
            w-full max-w-[280px]
            px-6 py-4 md:px-10 md:py-6
            bg-white
            rounded-full
            shadow-[0px_8px_30px_rgba(0,0,0,0.08)]
            text-sm md:text-[18px]
            text-neutral-800
            text-center
          "
        >
          {text}
        </div>
      ))}
    </div>

    {/* PHONE AREA */}
    <div className="relative flex flex-col items-center">

      {/* Background text (desktop only) */}
      <div className="hidden md:block absolute text-[220px] font-semibold text-red-600/5 right-[420px] top-[40px] whitespace-nowrap">
        Your
      </div>
      <div className="hidden md:block absolute text-[220px] font-semibold text-red-600/5 left-[420px] top-[40px] whitespace-nowrap">
        Deal
      </div>

      {/* PHONE */}
      <img
        src="/images/Webp/Mobile3.webp"
        className="relative w-[260px] sm:w-[320px] md:w-[420px] z-10 "
        alt="Phone preview"
      />

      {/* POINTS TEXT */}
      <div className="absolute bottom-[140px] sm:bottom-[170px] md:bottom-[200px] flex flex-col items-center z-20 ">
        <div className="text-2xl sm:text-3xl md:text-[38px] font-semibold text-neutral-900">
          4,700
        </div>
        <div className="text-neutral-500 text-sm md:text-[18px]">
          Points Available
        </div>
      </div>

      {/* VALUE CARD */}
      <div className="absolute bottom-[10px] sm:bottom-[15px] md:bottom-[20px] bg-gradient-to-r from-red-500/10 to-red-800/10 border border-red-500/30 rounded-2xl md:rounded-[28px] px-6 py-4 md:px-10 md:py-6 z-20 ">
        <div className="text-neutral-700 text-sm md:text-base mb-1">
          Value Unlocked
        </div>
        <div className="text-2xl md:text-[36px] font-semibold text-red-600">
          $47.00
        </div>
      </div>

      {/* FADE */}
      <div className="absolute bottom-0 w-full h-[120px] md:h-[220px] bg-gradient-to-t from-white to-transparent"/>
    </div>

    {/* CTA TEXT */}
    <p className="mt-12 md:mt-[80px] text-base md:text-[20px] text-neutral-700 leading-relaxed max-w-[95%] md:max-w-[600px]">
      For just{" "}
      <span className="text-red-600 font-semibold">$12/year</span>, unlock your points and get even more value!.
      
    </p>

    {/* BUTTON */}
    

  </div>

  {/* ANIMATIONS */}
  <style>
    {`
      @keyframes floatPhone {
        0%,100% { transform: translateY(0px); }
        50% { transform: translateY(-14px); }
      }

      @keyframes floatCard {
        0%,100% { transform: translateY(0px); }
        50% { transform: translateY(-10px); }
      }
    `}
  </style>

</section>
    
  );
};